import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=63bc17b8&scoped=true&"
import script from "./myProfile.vue?vue&type=script&lang=js&"
export * from "./myProfile.vue?vue&type=script&lang=js&"
import style0 from "./myProfile.vue?vue&type=style&index=0&id=63bc17b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc17b8",
  null
  
)

export default component.exports